import React, { lazy } from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const posts = [{
  category: 'Planning notes',
  title: 'A practical Manaslu packing list for every season',
  image: 'https://images.unsplash.com/photo-1517825738774-7de9363ef735?auto=format&fit=crop&w=900&q=85',
  alt: 'Hiker overlooking Himalayan foothills',
  to: '/journal/manaslu-packing-list'
}, {
  category: 'Trail journal',
  title: 'Why Samagaun is the cultural heart of the circuit',
  image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=900&q=85',
  alt: 'Mountain range beneath a clear sky',
  to: '/about/blogs'
}, {
  category: 'Mountain wisdom',
  title: 'How to prepare your body for a Himalayan pass',
  image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=900&q=85',
  alt: 'Forest hiking trail in the mountains',
  to: '/about/blogs'
}];
export function Blogs() {
  return <section className="bg-[#A48C5A] py-20 text-[#172a27] sm:py-28" data-id="element-38" data-mp="2p7nkk5ils0s0">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" data-id="element-39" data-mp="2kf46z8jx15n7">
        <div className="flex flex-wrap items-end justify-between gap-5" data-id="element-40" data-mp="2gdsgz1x4qieh">
          <div data-id="element-41" data-mp="2ge0tgspcblp5">
            <p className="text-xs font-bold uppercase tracking-[0.2em]" data-id="element-42" data-mp="2gbelwt2g966x">
              From the journal
            </p>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl" data-id="element-43" data-mp="384osnz7geh06">
              Keep reading the trail.
            </h2>
          </div>
          <Link to="/about/blogs" className="border-b border-[#172a27] pb-1 text-sm font-bold transition-colors hover:text-[#f7f4ec] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#172a27] focus-visible:ring-offset-4 focus-visible:ring-offset-[#A48C5A]" data-id="element-44" data-mp="344oe8ekcu5t4">
            View all stories
          </Link>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-45" data-mp="1iqac426la0fr">
          {posts.map(post => <article key={post.title} className="group" data-id="element-46" data-mp="1k7fmv4zb9asm">
              <Link to={post.to} className="block focus:outline-none focus-visible:ring-2 focus-visible:ring-[#172a27] focus-visible:ring-offset-4 focus-visible:ring-offset-[#A48C5A]" aria-label={`Read ${post.title}`} data-id="element-47" data-mp="1k7z4sloynz6n">
                <div className="overflow-hidden" data-id="element-48" data-mp="1g49gzyg41lmo">
                  <img src={post.image} alt={post.alt} className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-49" data-mp="11goea5n5dofa" />
                </div>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em]" data-id="element-50" data-mp="se6sttfbgztc">
                  {post.category}
                </p>
                <h3 className="mt-2 flex gap-2 font-display text-2xl leading-tight" data-id="element-51" data-mp="ihk9xa6jwity">
                  {post.title}
                  <ArrowUpRightIcon size={18} className="mt-1 shrink-0" aria-hidden="true" data-id="element-52" data-mp="nfvmvts579ge" />
                </h3>
                <span className="mt-4 inline-block border-b border-[#172a27] pb-1 text-sm font-bold" data-id="element-53" data-mp="3v2hnfrkwrkh3">
                  Read story
                </span>
              </Link>
            </article>)}
        </div>
      </div>
    </section>;
}